import React from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const mapDispatchToProps = dispatch => {
  return {

  };
};

const mapStateToProps = (state) => {
  return {
    progress: state.progress.progress
  };
}

const styles = {
  root: {
    flexGrow: 1,
  },
  colorPrimary: {
    backgroundColor: 'rgba(212,208,200,1)',
  },
  barColorPrimary: {
    backgroundColor: 'rgba(0,0,0,1)',
  },
};

class ConnectedCustomProgressBar extends React.PureComponent {
  render() {
    return (
      <div className={this.props.progress === 0 ? 'd-none' : 'd-flex align-items-center linear-progress-bar-container'} >
        <div className="linear-progress-bar">
        <LinearProgress
          variant="determinate"
          value={this.props.progress}
          classes={{
            colorPrimary: this.props.classes.colorPrimary,
            barColorPrimary: this.props.classes.barColorPrimary
          }}
        />
        </div>
        <div className="progress-amount">{this.props.progress}%</div>
      </div>
    )
  }
}

const CustomProgressBar = connect(mapStateToProps, mapDispatchToProps)(ConnectedCustomProgressBar)

export default withStyles(styles)(CustomProgressBar)



// WEBPACK FOOTER //
// ./src/js/components/Mui/CustomProgressBar.js